export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "—";
  const date = new Date(
    value.endsWith("Z") || value.includes("+") ? value : `${value}Z`,
  );
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

export function utcTooltip(value: string | null | undefined): string {
  if (!value) return "";
  const date = new Date(
    value.endsWith("Z") || value.includes("+") ? value : `${value}Z`,
  );
  return Number.isNaN(date.getTime()) ? value : date.toISOString();
}

export function displayName(user: {
  first_name: string;
  last_name: string | null;
}): string {
  return [user.first_name, user.last_name].filter(Boolean).join(" ") || "there";
}

/** Minor units (cents) to a localised amount, e.g. 500 USD → $5.00. */
export function formatMoney(amount: number, currency: string): string {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency || "USD",
  }).format(amount / 100);
}

export function formatCredits(value: number): string {
  return new Intl.NumberFormat(undefined).format(value);
}
